module.exports = ":host {\n  z-index: 1; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/main/content/content.component.scss
// module id = ./src/app/main/content/content.component.scss
// module chunks = main